// utils/loadGtag.ts
declare global {
  interface Window {
    dataLayer: any[];
  }
}

export function loadGtag(gtagId: string) {
  if (!gtagId) return;

  // Check if script already exists
  if (document.getElementById('gtag-script')) return;

  // 1. Load the external gtag.js script
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
  script.async = true;
  script.id = 'gtag-script';
  document.head.appendChild(script);
window.dataLayer = window.dataLayer || [];
function gtag(...args: any[]) {
  window.dataLayer.push(args);
}
(window as any).gtag = gtag;

gtag('js', new Date());
gtag('config', gtagId);
  // 2. Initialize gtag() after script is loaded
//   script.onload = () => {
//     // Init dataLayer
//     (window as any).dataLayer = (window as any).dataLayer || [];

//     // Create gtag function
//     const gtag = (...args: any[]) => {
//       (window as any).dataLayer.push(args);
//     };

//     // Make gtag globally accessible
//     (window as any).gtag = gtag;

//     // Initialize gtag
//     gtag('js', new Date());
//     gtag('config', gtagId);
//   };
}

